<template>
    <div>
         <b-loading  :active.sync="isFullScreenLoading" ></b-loading>
   
         <nav class="level is-mobile">
						<div class="level-left">
							<div class="level-item">
								<b-button type="is-success is-light" 
                                          icon-left="reload" 
                                          @click="fetchDataRawCBC">
                                          Reload Data Table
                                </b-button>
							</div>
                             <div class="level-item" v-if="dataRawCBC.length>0">
                                    <b-checkbox v-model="isSwitchedCusColumn">
                                         Table Manager
                                    </b-checkbox>
							</div>
                           
                             
						</div>
						<div class="level-right">
                                <div class="level-item mr-5">
                                 <span class="has-text-grey  has-text-weight-bold">
                                    LAB ID :
                                     <span class="has-text-black-ter has-text-weight-semibold">
                                        {{dataRawCBC_Filter_Spec_is_visible.length}}
                                    </span>   
                                    รายการ 
                                 </span>  
                                </div>
                                <div class="level-item ml-5">
                                 <span class="has-text-grey  has-text-weight-bold">
                                  Column Params. 
                                   <span class="has-text-black-ter has-text-weight-semibold">
                                     {{dataLabParamsMaster_Count_isSwitchedCUS1}}  
                                   </span>   
                                   รายการ
                                 </span>   
                                </div>
						</div>
					</nav>




            <section v-if="isSwitchedCusColumn" class="box mb-4 ">
                    
                   
                        <div class="columns">
                            <div class="column">
                                <span class="is-size-5 has-text-grey has-text-weight-bold"> 
                                LAB No. 
                                (    <span class="has-text-black-ter has-text-weight-semibold">
                                        {{dataRawCBC_Filter_Spec_is_visible.length}}
                                    </span>   
                                รายการ )
                               </span>      

                                <div class="has-text-black-ter">
                                        <b-table bordered 
                                               :data="dataRawCBC" 
                                               paginated 
                                               :per-page="tbldataRawCBCPerPage"
                                               :current-page.sync="currentPage_tbldataRawCBCPerPage"
                                               >
                                          <b-table-column label="#" width="20%" centered   >
                                                    


                                                    <template v-slot:header >
                                                       <b-dropdown aria-role="list">
                                                                <template #trigger>
                                                                     <b-button  
                                                                      type="is-ghost"
                                                                      icon-right="dots-vertical" />
                                                                </template>
                                                                <b-dropdown-item aria-role="listitem" @click="selectAllLabInThisPage">Select All</b-dropdown-item>
                                                                <b-dropdown-item aria-role="listitem" @click="unSelectAllLabInThisPage">Unselect All</b-dropdown-item>
                                                      </b-dropdown>
                                                    </template>
                                                    <template v-slot="props">
                                                           <b-switch type="is-success"
                                                                v-model="props.row.is_visible"  >
                                                            </b-switch>
                                                    </template>






                                          </b-table-column>      
                                          <b-table-column label="LAB ID." width="40%" centered  v-slot="props">
                                                 {{props.row.idlab}}
                                          </b-table-column> 
                                          <b-table-column label="D/T" width="40%"   v-slot="props">
                                                <span class="is-size-7 ml-2 tag is-info is-light">
                                                        {{getDateTimeFromIDLAB(props.row.idlab).date_req}}
                                                        {{getDateTimeFromIDLAB(props.row.idlab).time_req}}
                                                    </span>  
                                          </b-table-column>          

                                        </b-table>
                                </div>
                            </div>
                              
                            <div class="column ">
                                <span :class="searchTxtParam.length>0 ? 'is-size-4 has-text-info': 'is-size-5 '  "> 
                                     

                                    <span class="is-size-5 has-text-grey has-text-weight-bold"> 
                                        Columns 
                                        (    <span class="has-text-black-ter has-text-weight-semibold">
                                                {{dataLabParamsMaster_Count_isSwitchedCUS1}}
                                            </span>   
                                        รายการ )
                                    </span>   



                                            <b-tooltip label="Clear Filter" >
                                               <b-button type="is-info is-light"
                                                v-if="searchTxtParam.length>0"
                                                size="is-small"
                                                @click="searchTxtParam = '' "
                                                icon-right="filter" />
                                            </b-tooltip>
                                         
                                </span>
                                 <b-tooltip label="Sort Parameters" >
                                      
                                    <b-button type="is-text"
                                                size="is-small"
                                                @click="showDlgParamSortMode(cusNoToChild)"  
                                                icon-right="sort" 
                                                outlined />
                                  </b-tooltip>        
                                  
                                   <b-tooltip label="Save Sort Order" >
                                    <b-button type="is-text"
                                                size="is-small"
                                                @click="saveParamSort" 
                                                icon-right="cloud-upload" 
                                                outlined />
                                  </b-tooltip>          




                                <b-input placeholder="Search Param" v-model="searchTxtParam"  ></b-input>
                                <div class="">
                                        <b-table bordered 
                                               :data="dataLabParamsMasterFilter" 
                                               paginated 
                                               :per-page="tblDataLabParamsMasterperPage"
                                               :current-page.sync="currentPage_tblDataLabParamsMasterperPage"
                                               >
                                          <b-table-column label="#" width="20%"   >
                                                    <template v-slot:header >
                                                       <b-dropdown aria-role="list" v-if="searchTxtParam.length==0">
                                                                <template #trigger>
                                                                     <b-button  
                                                                      type="is-ghost"
                                                                      icon-right="dots-vertical" />
                                                                </template>
                                                                <b-dropdown-item aria-role="listitem" @click="selectAllParamsInThisPage">Select All</b-dropdown-item>
                                                                <b-dropdown-item aria-role="listitem" @click="unSelectAllParamsInThisPage">Unselect All</b-dropdown-item>
                                                      </b-dropdown>
                                                    </template>
                                                    <template v-slot="props">
                                                          <b-switch type="is-success" 
                                                            @input = "inputIsSwitchedCUS1(props.row)"
                                                            v-model="props.row.isSwitchedCUS1">
                                                          </b-switch>
                                                    </template>
                                          </b-table-column>      
                                          <b-table-column label="Param." width="40%"   v-slot="props">
                                                 <text-highlight :queries="queries">   {{ props.row.label }} </text-highlight>
                                          </b-table-column> 
                                          <b-table-column label="Param." width="40%"   v-slot="props">
                                                <text-highlight :queries="queries">    {{ props.row.label_1 }}</text-highlight>
                                          </b-table-column>    

                                           <b-table-column label="order." :visible="false"    v-slot="props">
                                                 {{ props.row.order }} 
                                          </b-table-column>          

                                        </b-table>
                                </div>
                            </div>
                        </div>



                    
                    
                    
            </section>

 
 
            <b-table bordered 
                                :data="dataRawCBC_Filter_Spec_is_visible" 
                                class="is-success mb-5" 
                                :sticky-header="stickyHeader" 
                                :height="calTblHigth"
                                
                                :paginated="paginatedLABIDTblMode"
                                :per-page="tblRawCBCperPage"
                                :current-page.sync="currentPage_tblRawCBCperPage"
                                
                                >

                                <template v-for="column in computeColumn">
                                    <b-table-column :key="column.uuid" v-bind="column">
                                        <template v-slot:header="{ column }">
                                            <b-tooltip position="is-bottom" multilined v-if="isColumnField(column.field)">

                                                <template v-slot:content>
                                                    <b>Remove</b> <i>{{column.label}}</i>.
                                                </template>



                                                        <b-button 
                                                            v-if="isColumnField(column.field)"  
                                                            size="is-small"
                                                            @click="removeColumn(column.field)"
                                                            icon-left="delete"
                                                            type="is-text"
                                                            >  {{column.label}}</b-button>
                                                
                                            </b-tooltip>
                                                        
                                                        <span
                                                        v-else
                                                        >
                                                        
                                                        <span v-if="column.field=='idlab' ">
                                                        
                                                                <b-dropdown aria-role="list" >
                                                                        <template #trigger>
                                                                            <b-button  
                                                                            class=""
                                                                            type="is-ghost"
                                                                            icon-right="dots-vertical" >{{column.label}}</b-button>
                                                                        </template>
                                                                        <b-dropdown-item aria-role="listitem" @click="paginatedLABIDTblMode = !paginatedLABIDTblMode">{{ paginatedLABIDTblMode ? 'Turn off Paginated' :  'Turn on Paginated'}}</b-dropdown-item>
                                                                </b-dropdown>
                                                        
                                                        
                                                        
                                                        </span>
                                                        <span v-else> 
                                                            {{column.label}}
                                                        </span>  
                                                    



                                                        </span>    
                                                    
                                                    
                                        </template>
                                        <template v-slot="props">
                                            <span v-if=" column.field =='idlab' ">


                                                    {{ props.row[column.field] }} 
                                                    
                                                        <b-button 
                                                            size="is-small"
                                                            @click="removeRowOfIDLAB(props.row[column.field])"
                                                            icon-left="delete"
                                                            type="is-text  "
                                                            >     </b-button>    
                                                        
                                            </span>
                                            <span v-else>
                                                {{ props.row[column.field] }} 
                                            </span>




                                        </template>
                                    </b-table-column>
                                </template>
                            
            </b-table>
                
                
                

           <section v-if="dataRawCBC.length>0" :class="isSwitchedChartRawCBC ? 'box' : '' ">

                    <b-checkbox v-model="isSwitchedChartRawCBC">
                                            Chart
                    </b-checkbox>  
 
                    <ChartRawCBC 
                    v-if="isSwitchedChartRawCBC"
                    :rawCBCData="dataRawCBC_Filter_Spec_is_visible" 
                    :cusNoToChild="cusNoToChild"
                    />


           </section>


        <b-modal
                v-if="isSortCBCTableShowing"
                v-model="isSortCBCTableShowing"
                has-modal-card
                full-screen
                :can-cancel="true">
            <SortCBCTable v-if="isSortCBCTableShowing"
                     :cusNo="cusNoToChild" 
                     :isShowing="isSortCBCTableShowing"
                     @close="closeSortCBCTableShowing"
                    
            />
        </b-modal>  






    </div>
</template>


<script>
import { mapState } from "vuex";
import axios from "axios";
import { getBaseURLforBackEnd  , getConfigAxios ,  genUUID }  from '@/utils.js'
import _ from 'lodash'

import SortCBCTable  from "../ViewLabForOPDSpace/SortCBCTable.vue"
import ChartRawCBC from "../ViewLabForOPDSpace/ChartRawCBC.vue"


export default {
    name : "TableAndChartCBC",
    components:{
        ChartRawCBC,
        SortCBCTable,
    },
    props:{
       // dataRawCBC : Array,
       cusNoToChild : String,  // "cus0", "cus1" ,"cus2"
    },
    computed:{
         ...mapState({
               dataLabParamsMaster : state => state.master_data.dataLabParamsMaster,
               dataLabParamsMaster_1 : state => state.master_data.dataLabParamsMaster_1,
               dataLabParamsMaster_2 : state => state.master_data.dataLabParamsMaster_2,


               access_token: state => state.master_data.access_token,
            //    opdInfoInVetRoom : state => state.vetroom.opdInfoInVetRoom ,
               OPDSelected : state => state.opd_target.opd_selected,
               clientIP: state => state.master_data.clientIP,
              // userInfo: state => state.master_data.userInfo,
            //   userName: state => state.master_data.userName,
            user_id: state => state.master_data.user_id,
            
         }),
        computeColumn(){
                // const arrDataFromCusNo = this.selectDataLabParamsMasterByCusNo()
                const tmp0 =_.sortBy(this.arrDataFromCusNo, 'order'); 
                // console.log(tmp0)
                const tmp = tmp0.filter(dat=>dat.isSwitchedCUS1)
                 
                let tmp1 = tmp.map(dat=>{
                                                 return { field : dat.key, label : dat.label,width : 50 , centered : true ,headerClass: "is-sticky-column-one" , uuid : genUUID(4) } 
                                               }) 
                
                 
                tmp1.unshift({ field: 'time_req', label: 'Time' ,width : 60    , uuid:  genUUID(4)  } )
                tmp1.unshift({ field: 'date_req', label: 'Date' ,width : 120    , uuid:  genUUID(4) } )
                tmp1.unshift({ field: 'idlab', label: 'LAB ID' ,width : 40 , sticky: true,  headerClass: "is-sticky-column-one",  cellClass: "is-sticky-column-two" , uuid:  genUUID(4)} )
            


                return tmp1                               
        }, 
        calTblHigth(){
               return this.dataRawCBC_Filter_Spec_is_visible.length>10 ?  "700" : "auto"
        }, 
        queries(){
                return this.searchTxtParam.split(" ");
        }, 
        dataRawCBC_Filter_Spec_is_visible(){
                 return this.dataRawCBC.filter(dat=>dat.is_visible)
        },
        dataLabParamsMaster_Count_isSwitchedCUS1(){
                // const arrDataFromCusNo = this.selectDataLabParamsMasterByCusNo()
                return this.arrDataFromCusNo.filter(dat=>dat.isSwitchedCUS1)
                                               .length 
        },
        dataLabParamsMasterFilter : function(){
            //    const arrDataFromCusNo = this.selectDataLabParamsMasterByCusNo()
               return this.arrDataFromCusNo.filter(dat=>{
                if (
                        (dat.label.toUpperCase().indexOf(this.searchTxtParam.toUpperCase()) > -1  )
                   ||   (dat.label_1.toUpperCase().indexOf(this.searchTxtParam.toUpperCase()) > -1  )
                   
                   ){
                      
                        return  dat
                    }
            })
        },
         
    },
    methods:{
         inputIsSwitchedCUS1(_field){
                console.log(_field)
         },
         selectDataLabParamsMasterByCusNo(){
            if (this.cusNoToChild  == "cus0"){
                return this.dataLabParamsMaster
            }else if (this.cusNoToChild  == "cus1"){
                return this.dataLabParamsMaster_1
            }else if (this.cusNoToChild  == "cus2"){
                return this.dataLabParamsMaster_2
            }

            return []
         },
         saveParamSort(){
               
               

               let datTo = {
                "cus_no" : "",
                "data" : null
               }
            //    if (cusNo == 0){
               if (this.cusNoToChild  == "cus0"){
               datTo.cus_no =   "cus1"
               datTo.data =   this.dataLabParamsMaster 
               }else  if (this.cusNoToChild  == "cus1"){
               datTo.cus_no =   "cus2" 
               datTo.data =  this.dataLabParamsMaster_1  
               }else if (this.cusNoToChild  == "cus2"){
               datTo.cus_no =   "cus3" 
               datTo.data =  this.dataLabParamsMaster_2  
               }

               this.isFullScreenLoading = true 
               axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
               axios.post(`${getBaseURLforBackEnd()}/api/upcuscbc`, datTo, getConfigAxios())
                    .then((res)=>{
                         this.$buefy.toast.open({
                                    duration: 2000,
                                    message: `${res.data.msg}`,
                                    type: 'is-success'
                         })
                         this.isFullScreenLoading = false
                    })

                    .catch((err)=>{
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'alert-circle',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                        this.isFullScreenLoading = false
                    })
                   


         }, 
         closeSortCBCTableShowing(){
                this.isSortCBCTableShowing = false
         },
         showDlgParamSortMode(cusNo){
                this.cusNoToChild = cusNo
                this.isSortCBCTableShowing = true
         },

         removeColumn(_column_field){
            //    const arrDataFromCusNo = this.selectDataLabParamsMasterByCusNo()
               const tmp =  this.arrDataFromCusNo.find(dat=>dat.key ==  _column_field)
           
               if(tmp){
                tmp.isSwitchedCUS1 = false
               }   
         },
         removeRowOfIDLAB(_idlab){
            const tmp = this.dataRawCBC.find(dat=>dat.idlab == _idlab)
            if(tmp){
                tmp.is_visible = false
            }
         },
         isColumnField(column_field){
            //   const arrDataFromCusNo = this.selectDataLabParamsMasterByCusNo()
              return this.arrDataFromCusNo.find(dat=>dat.key == column_field)
         },
         selectAllLabInThisPage(){
            const arr = _.chunk( this.dataRawCBC.map(dat=>dat.idlab),this.tbldataRawCBCPerPage)
            const arrWant = arr[this.currentPage_tbldataRawCBCPerPage-1]
            //
            this.dataRawCBC.forEach(dat=>{
                if (arrWant.indexOf( dat.idlab )>-1){
                    dat.is_visible = true
                }
            }) 
            

         },
         unSelectAllLabInThisPage(){
            const arr = _.chunk( this.dataRawCBC.map(dat=>dat.idlab),this.tbldataRawCBCPerPage)
            const arrWant = arr[this.currentPage_tbldataRawCBCPerPage-1]
            //
            this.dataRawCBC.forEach(dat=>{
                if (arrWant.indexOf( dat.idlab )>-1){
                    dat.is_visible = false
                }
            }) 
            

         }, 
         selectAllParamsInThisPage(){
            // const arrDataFromCusNo = this.selectDataLabParamsMasterByCusNo()
            const tmpArr = this.arrDataFromCusNo.map(dat=>dat.key)
            const tmpArr1 =  _.sortBy(tmpArr,"order") 
            const arr = _.chunk(  tmpArr1 ,this.tblDataLabParamsMasterperPage)
            const arrWant = arr[this.currentPage_tblDataLabParamsMasterperPage-1]
            //
            this.arrDataFromCusNo.forEach(dat=>{
                if (arrWant.indexOf( dat.key )>-1){
                    dat.isSwitchedCUS1 = true
                }
            }) 
            

           },
           unSelectAllParamsInThisPage(){
            // const arrDataFromCusNo = this.selectDataLabParamsMasterByCusNo()
            const tmpArr = this.arrDataFromCusNo.map(dat=>dat.key)
            const tmpArr1 =  _.sortBy(tmpArr,"order") 
            const arr = _.chunk(  tmpArr1 ,this.tblDataLabParamsMasterperPage)
            const arrWant = arr[this.currentPage_tblDataLabParamsMasterperPage-1]
            //
            this.arrDataFromCusNo.forEach(dat=>{
                if (arrWant.indexOf( dat.key )>-1){
                    dat.isSwitchedCUS1 = false
                }
            }) 
            

           }, 


         getDateTimeFromIDLAB(_idlab){
                const tmp = this.dataRawCBC.find(dat=>dat.idlab==_idlab)
                return tmp ? 
                           {
                            "date_req" : tmp.date_req,
                            "time_req" : tmp.time_req,
                           }
                           :
                           {
                            "date_req" : "",
                            "time_req" : "",
                           }
         },
         fetchDataRawCBC(){
               

                const dat =     {
                    "opdno":  this.OPDSelected.idopd ,//this.opdInfoInVetRoom.idopd ,
                    "user": this.user_id,
                    "ip":  this.clientIP
                }
                 
                this.isFullScreenLoading = true
                this.isSwitchedCusColumn = false
                this.isSwitchedChartRawCBC = false

          
                
                // console.log(JSON.stringify(dat))
                 
                // attach access_token it
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/labcbclist_spec_opdno_v2`,dat,getConfigAxios())
                    .then( (res)=> {
                        this.dataRawCBC = [] // reset old data
                        this.dataRawCBC = res.data
                      
                        
                       
                        this.currentPage_tblRawCBCperPage = 1
                        this.currentPage_tbldataRawCBCPerPage = 1
                        this.paginatedLABIDTblMode = true
                        this.searchTxtParam = ""
                        
                        // reset chart
                        this.chartXAxis = []
                        this.chartYAxis = []
 
                        //  console.log(this.dataRawCBC)
                        const MAX_COUNT_VISIBLE  =  this.dataRawCBC.length>4 ? 4 :this.dataRawCBC.length-1
                        for(var i=0;i<=MAX_COUNT_VISIBLE;i++){
                               this.dataRawCBC[i].is_visible= true
                        } 
                        //    this.dataRawCBC[0].is_visible= true
                        //    this.dataRawCBC[1].is_visible= true
                         
                       
                        // pick up dataLabParamsMaster from cusNoToChild Props
                        this.arrDataFromCusNo = this.selectDataLabParamsMasterByCusNo()
                        // console.log(this.arrDataFromCusNo )



                        this.isFullScreenLoading = false
                     
                      

                    })
                    .catch(function (err) {
                        this.$buefy.toast.open({
                            duration: 1400,
                            message: `Sometime wrong with ${err} pls try again `,
                            position: 'is-bottom',
                            type: 'is-danget'
                        })
                        this.isFullScreenLoading = false
                    })
                    .finally(()=>{
                        this.isFullScreenLoading = false
                    })

                 
            },
    },
    data(){
        return {
            dataRawCBC : [],

            isFullScreenLoading : false,
            isSwitchedCusColumn : false,
            isSwitchedChartRawCBC : false,


            currentPage_tblRawCBCperPage : 1, 
            currentPage_tbldataRawCBCPerPage : 1,
            paginatedLABIDTblMode : true,
            searchTxtParam: "",


            tbldataRawCBCPerPage : 10,
            tblDataLabParamsMasterperPage : 10,
            currentPage_tblDataLabParamsMasterperPage : 1,
            tblRawCBCperPage : 10,


            stickyHeader : true,

            isSortCBCTableShowing : false,
            // cusNoToChild : "cus0",// "cus0", "cus1" ,"cus2"
            arrDataFromCusNo : [],
        }
    }
}
</script>


<style >
 

    .is-sticky-column-one {
    background: #edeeee !important;
    color: rgb(67, 127, 154) !important;
    }


    .is-sticky-column-two {
        background: #167df0 !important;
        color: white !important;
    }
    
 

 

</style>